const state = {
  profitabilityCFNAI : [],
  probabilitybasedonyieldcurve : [],
  macro: [],
  recessionrisk: [],
  leadingindicator: [],
  oecdleadingindiCJB: [],
  usindustrialproduction: [],
  ipindexyoy: [],
  ismvswtioilyoy: [],
  tradedweighted: [],
  usipcagr: [],
  gdp: [],
  eugdpforecast: [],
  belgianindustrial:[],
  ecbmoneysupply:[],
  euchemicalsconfidence:[],
  inventory:[],
  isminventoriessurvey:[],
  finalsalesvsinventories:[],
  chemicalsectorpricingpower:[],
  consumerspending:[],
  pceforecast:[],
  realgdpforecast:[],
  fedfundrateconsumerspending:[],
  durableinvestment:[],
  usconstruction:[],
  residentialnonresidentialconstruction:[],
  newfamilyhomes:[],
  usconstructionspending:[],
  nahbleadsfinalsaleshousingstart:[],
  inflationhardertopace:[],
  ppiintermediategoods:[],
  ppifinishedgoods:[],
  govtoutlays:[],
  inflation:[],
  uscpi:[],
  brentvsnaturalgas:[],
  cpivsppi:[],
  chemicalsectorpricing:[],
  capitalspending:[],
  capexyoy:[],
  fedcapindex:[],
  capexcycle:[],
  chemicalsectorcapex:[],
  corn:[],
  cornyoy:[],
  cornyield:[],
  cornprofitmargins:[],
  netdebteditda:[],
  deleveraging:[],
  rollingnetdebtebitda:[],
  regionaltrends:[],
  euvsuscpi:[],
  consumersentiment:[],
  gdptreasuryyield:[],
  nominalgdplessfedfund:[],
  year10treasuryless3montheuro:[],
  keybankratesfececbetc:[],
  keybankrateschinabrazil:[],
  cpiandsentiments:[],
  riskspread:[],
  riskspreadChart1:[],
  riskspreadChart2:[],
  riskspreadChart3:[],
  riskspreadChart4:[],
  oecdleadingindicatorsglobalusandeurope:[],
  usleadingindicator3mo6mo12mochange:[],
  chinaleadingindicatormomomochange:[],
  recessioncriteriachangevsendoflastrecession:[],
  impactofswingincunsumerdemandonsuppliers:[],
  ratioconincidentlaggingleiyoyvsrecessiontiming:[],
  globalStateForWholeProject: [],
  retailSales: [],
  realRetailSales: [],
  effectiveTaxRate: [],
};
const getters = {
  profitabilityCFNAI : (state) => state.profitabilityCFNAI,
  cpiandsentiments : (state) => state.cpiandsentiments,
  riskspread : (state) => state.riskspread,
  riskspreadChart1 : (state) => state.riskspreadChart1,
  riskspreadChart2 : (state) => state.riskspreadChart2,
  riskspreadChart3 : (state) => state.riskspreadChart3,
  riskspreadChart4 : (state) => state.riskspreadChart4,
  probabilitybasedonyieldcurve : (state) => state.probabilitybasedonyieldcurve,
  macro : (state) => state.macro,
  recessionrisk : (state) => state.recessionrisk,
  leadingindicator : (state) => state.leadingindicator,
  oecdleadingindiCJB: (state) => state.oecdleadingindiCJB,
  usindustrialproduction: (state) => state.usindustrialproduction,
  ipindexyoy: (state) => state.ipindexyoy,
  ismvswtioilyoy: (state) => state.ismvswtioilyoy,
  tradedweighted: (state) => state.tradedweighted,
  usipcagr: (state) => state.usipcagr,
  gdp: (state) => state.gdp,
  eugdpforecast: (state) => state.eugdpforecast,
  belgianindustrial: (state) => state.belgianindustrial,
  ecbmoneysupply: (state) => state.ecbmoneysupply,
  euchemicalsconfidence: (state) => state.euchemicalsconfidence,
  inventory: (state) => state.inventory,
  isminventoriessurvey: (state) => state.isminventoriessurvey,
  finalsalesvsinventories: (state) => state.finalsalesvsinventories,
  chemicalsectorpricingpower: (state) => state.chemicalsectorpricingpower,
  consumerspending: (state) => state.consumerspending,
  pceforecast: (state) => state.pceforecast,
  realgdpforecast: (state) => state.realgdpforecast,
  fedfundrateconsumerspending: (state) => state.fedfundrateconsumerspending,
  durableinvestment: (state) => state.durableinvestment,
  usconstruction: (state) => state.usconstruction,
  residentialnonresidentialconstruction: (state) => state.residentialnonresidentialconstruction,
  newfamilyhomes: (state) => state.newfamilyhomes,
  usconstructionspending: (state) => state.usconstructionspending,
  nahbleadsfinalsaleshousingstart: (state) => state.nahbleadsfinalsaleshousingstart,
  inflationhardertopace: (state) => state.inflationhardertopace,
  ppiintermediategoods: (state) => state.ppiintermediategoods,
  ppifinishedgoods: (state) => state.ppifinishedgoods,
  govtoutlays: (state) => state.govtoutlays,
  inflation: (state) => state.inflation,
  uscpi: (state) => state.uscpi,
  brentvsnaturalgas: (state) => state.brentvsnaturalgas,
  cpivsppi: (state) => state.cpivsppi,
  chemicalsectorpricing: (state) => state.chemicalsectorpricing,
  capitalspending: (state) => state.capitalspending,
  capexyoy: (state) => state.capexyoy,
  fedcapindex: (state) => state.fedcapindex,
  capexcycle: (state) => state.capexcycle,
  chemicalsectorcapex: (state) => state.chemicalsectorcapex,
  corn: (state) => state.corn,
  cornyoy: (state) => state.cornyoy,
  cornyield: (state) => state.cornyield,
  cornprofitmargins: (state) => state.cornprofitmargins,
  netdebteditda: (state) => state.netdebteditda,
  deleveraging: (state) => state.deleveraging,
  rollingnetdebtebitda: (state) => state.rollingnetdebtebitda,
  regionaltrends: (state) => state.regionaltrends,
  euvsuscpi: (state) => state.euvsuscpi,
  consumersentiment: (state) => state.consumersentiment,
  gdptreasuryyield: (state) => state.gdptreasuryyield,
  nominalgdplessfedfund: (state) => state.nominalgdplessfedfund,
  year10treasuryless3montheuro: (state) => state.year10treasuryless3montheuro,
  keybankratesfececbetc: (state) => state.keybankratesfececbetc,
  keybankrateschinabrazil: (state) => state.keybankrateschinabrazil,
  oecdleadingindicatorsglobalusandeurope: (state) => state.oecdleadingindicatorsglobalusandeurope,
  usleadingindicator3mo6mo12mochange: (state) => state.usleadingindicator3mo6mo12mochange,
  chinaleadingindicatormomomochange: (state) => state.chinaleadingindicatormomomochange,
  recessioncriteriachangevsendoflastrecession: (state) => state.recessioncriteriachangevsendoflastrecession,
  impactofswingincunsumerdemandonsuppliers: (state) => state.impactofswingincunsumerdemandonsuppliers,
  ratioconincidentlaggingleiyoyvsrecessiontiming: (state) => state.ratioconincidentlaggingleiyoyvsrecessiontiming,
  globalStateForWholeProject: (state) => state.globalStateForWholeProject,
  retailSales: (state) => state.retailSales,
  realRetailSales: (state) => state.realRetailSales,
  effectiveTaxRate: (state) => state.effectiveTaxRate,
  
};
const actions = {
    cpiandsentimentsHandler ({ commit }, cpiandsentiments) {
        commit("SET_CPIANDSENTIMENTS", cpiandsentiments);
    },
    riskspreadHandler ({ commit }, riskspread) {
        commit("SET_RISKSPREAD", riskspread);
    },
    riskspread1Handler ({ commit }, riskspread1) {
        commit("SET_UPPER_LEFT_CHART", riskspread1);
    },
    riskspread2Handler ({ commit }, riskspread2) {
        commit("SET_UPPER_RIGHT_CHART", riskspread2);
    },
    riskspread3Handler ({ commit }, riskspread3) {
        commit("SET_LOWER_LEFT_CHART", riskspread3);
    },
    riskspread4Handler ({ commit }, riskspread4) {
        commit("SET_LOWER_RIGHT_CHART", riskspread4);
    },
};
const mutations = {
  SET_PROBABILITYBASEDONCFNAI(state,profitabilityCFNAI){
    state.profitabilityCFNAI = profitabilityCFNAI;
},
SET_PROBABILITYBASEDONYIELDCURVE(state,probabilitybasedonyieldcurve){
    state.probabilitybasedonyieldcurve = probabilitybasedonyieldcurve;
},
SET_MACRO(state,macro){
    state.macro = macro;
},
SET_RECESSIONRISK(state,recessionrisk){
    state.recessionrisk = recessionrisk;
},
SET_LEADINGINDICATOR(state,leadingindicator){
    state.leadingindicator = leadingindicator;
},
SET_OECDLEADINGINDICATORSCHINAJAPANBRAZIL(state,oecdleadingindiCJB){
    state.oecdleadingindiCJB = oecdleadingindiCJB;
},
SET_USINDUSTRIALPRODUCTION(state,usindustrialproduction){
    state.usindustrialproduction = usindustrialproduction;
},
SET_IPINDEXYOY(state,ipindexyoy){
    state.ipindexyoy = ipindexyoy;
},
SET_ISMVSWTIOILYOY(state,ismvswtioilyoy){
    state.ismvswtioilyoy = ismvswtioilyoy
},
SET_TRADEDWEIGHTED(state,tradedweighted){
    state.tradedweighted = tradedweighted
},
SET_USIPCAGR(state,usipcagr){
    state.usipcagr = usipcagr;
},
SET_GDP(state,gdp){
    state.gdp = gdp;
},
SET_EUGDPFORECAST(state,eugdpforecast){
    state.eugdpforecast = eugdpforecast;
},
SET_BELGIANINDUSTRIALCONFIDENCEVSECBLENDINGEASING(state,belgianindustrial){
    state.belgianindustrial = belgianindustrial;
},
SET_ECBMONEYSUPPLY(state,ecbmoneysupply){
    state.ecbmoneysupply = ecbmoneysupply;
},
SET_EUCHEMICALSIPVSEUINDUSTRIALCONFIDENCE(state,euchemicalsconfidence){
    state.euchemicalsconfidence = euchemicalsconfidence;
},
SET_INVENTORY(state,inventory){
    state.inventory = inventory;
},
SET_ISMINVENTORIESSURVEY(state,isminventoriessurvey){
    state.isminventoriessurvey = isminventoriessurvey;
},
SET_FINALSALESVSINVENTORIES(state,finalsalesvsinventories){
    state.finalsalesvsinventories = finalsalesvsinventories;
},
SET_CHEMICALSECTORPRICINGPOWER(state,chemicalsectorpricingpower){
    state.chemicalsectorpricingpower = chemicalsectorpricingpower;
},
SET_CONSUMERSPENDING(state,consumerspending){
    state.consumerspending = consumerspending;
},
SET_PCEFORECAST(state,pceforecast){
    state.pceforecast = pceforecast;
},
SET_REALGDPFORECAST(state,realgdpforecast){
    state.realgdpforecast = realgdpforecast;
},
SET_FEDFUNDRATECONSUMERSPENDING(state,fedfundrateconsumerspending){
    state.fedfundrateconsumerspending = fedfundrateconsumerspending;
},
SET_DURABLEINVESTMENT(state,durableinvestment){
    state.durableinvestment = durableinvestment;
},
SET_USCONSTRUCTION(state,usconstruction){
    state.usconstruction = usconstruction;
},
SET_RESIDENTIALNONRESIDENTIALCONSTRUCTION(state,residentialnonresidentialconstruction){
    state.residentialnonresidentialconstruction = residentialnonresidentialconstruction;
},
SET_NEWFAMILYHOMES(state,newfamilyhomes){
    state.newfamilyhomes = newfamilyhomes;
},
SET_USCONSTRUCTIONSPENDING(state,usconstructionspending){
    state.usconstructionspending = usconstructionspending;
},
SET_NAHBLEADSFINALSALESHOUSINGSTART(state,nahbleadsfinalsaleshousingstart){
    state.nahbleadsfinalsaleshousingstart = nahbleadsfinalsaleshousingstart;
},
SET_INFLATIONHARDERTOPACE(state,inflationhardertopace){
    state.inflationhardertopace = inflationhardertopace;
},
SET_PPIINTERMEDIATEGOODS(state,ppiintermediategoods){
    state.ppiintermediategoods = ppiintermediategoods;
},
SET_PPIFINISHEDGOODS(state,ppifinishedgoods){
    state.ppifinishedgoods = ppifinishedgoods;
},
SET_GOVTOUTLAYS(state,govtoutlays){
    state.govtoutlays = govtoutlays;
},
SET_INFLATION(state,inflation){
    state.inflation = inflation;
},
SET_USCPI(state,uscpi){
    state.uscpi = uscpi;
},
SET_BRENTVSNATURALGAS(state,brentvsnaturalgas){
    state.brentvsnaturalgas = brentvsnaturalgas;
},
SET_CPIVSPPI(state,cpivsppi){
    state.cpivsppi = cpivsppi;
},
SET_CHEMICALSECTORPRICING(state,chemicalsectorpricing){
    state.chemicalsectorpricing = chemicalsectorpricing;
},
SET_CAPITALSPENDING(state,capitalspending){
    state.capitalspending = capitalspending;
},
SET_CAPEXYOY(state,capexyoy){
    state.capexyoy = capexyoy;
},
SET_FEDCAPINDEX(state,fedcapindex){
    state.fedcapindex = fedcapindex;
},
SET_CAPEXCYCLE(state,capexcycle){
    state.capexcycle = capexcycle;
},
SET_CHEMICALSECTORCAPEX(state,chemicalsectorcapex){
    state.chemicalsectorcapex = chemicalsectorcapex;
},
SET_CORN(state,corn){
    state.corn = corn;
},
SET_CORNYOY(state,cornyoy){
    state.cornyoy = cornyoy;
},
SET_CORNPROFITMARGINS(state,cornprofitmargins){
    state.cornprofitmargins = cornprofitmargins;
},
SET_CORNYIELD(state,cornyield){
    state.cornyield = cornyield;
},
SET_NETDEBTEDITDA(state,netdebteditda){
    state.netdebteditda = netdebteditda;
},
SET_DELEVERAGING(state,deleveraging){
    state.deleveraging = deleveraging;
},
SET_ROLLINGNETDEBTEBITDA(state,rollingnetdebtebitda){
    state.rollingnetdebtebitda = rollingnetdebtebitda;
},
SET_RETAIL_SALES (state, retailSales) {
    state.retailSales = retailSales;
},
SET_REALRETAILSALES (state, realRetailSales) {
    state.realRetailSales = realRetailSales;
},
SET_EFFECTIVETAXRATE (state, effectiveTaxRate) {
    state.effectiveTaxRate = effectiveTaxRate;
},
SET_REGIONALTRENDS(state,regionaltrends){
    state.regionaltrends = regionaltrends;
},
SET_EUVSUSCPI(state,euvsuscpi){
    state.euvsuscpi = euvsuscpi;
},
SET_CONSUMERSENTIMENT(state,consumersentiment){
    state.consumersentiment = consumersentiment;
},
SET_CPIANDSENTIMENTS(state,cpiandsentiments){
    state.cpiandsentiments = cpiandsentiments;
},
SET_RISKSPREAD(state,riskspread){
    state.riskspread = riskspread;
},
SET_UPPER_LEFT_CHART(state,riskspreadChart1){
    state.riskspreadChart1 = riskspreadChart1;
},
SET_UPPER_RIGHT_CHART(state,riskspreadChart2){
    state.riskspreadChart2 = riskspreadChart2;
},
SET_LOWER_LEFT_CHART(state,riskspreadChart3){
    state.riskspreadChart3 = riskspreadChart3;
},
SET_LOWER_RIGHT_CHART(state,riskspreadChart4){
    state.riskspreadChart4 = riskspreadChart4;
},
SET_GDPTREASURYYIELD(state,gdptreasuryyield){
    state.gdptreasuryyield = gdptreasuryyield;
},
SET_NOMINALGDPLESSFEDFUND(state,nominalgdplessfedfund){
    state.nominalgdplessfedfund = nominalgdplessfedfund;
},

SET_10YEARTREASURYLESS3MONTHEURO(state,year10treasuryless3montheuro){
    state.year10treasuryless3montheuro = year10treasuryless3montheuro;
},
SET_KEYBANKRATESFECECBETC(state,keybankratesfececbetc){
    state.keybankratesfececbetc = keybankratesfececbetc;
},
SET_KEYBANKRATESCHINABRAZIL(state,keybankrateschinabrazil){
    state.keybankrateschinabrazil = keybankrateschinabrazil;
},
SET_OECDLEADINGINDICATORSGLOBALUSANDEUROPE(state,oecdleadingindicatorsglobalusandeurope){
    state.oecdleadingindicatorsglobalusandeurope = oecdleadingindicatorsglobalusandeurope;
},
SET_USLEADINGINDICATOR3MO6MO12MOCHANGE(state,usleadingindicator3mo6mo12mochange){
    state.usleadingindicator3mo6mo12mochange = usleadingindicator3mo6mo12mochange;
},
SET_CHINALEADINGINDICATOR3MO6MO12MOCHANGE(state,chinaleadingindicatormomomochange){
    state.chinaleadingindicatormomomochange = chinaleadingindicatormomomochange;
},
SET_RECESSIONCRITERIACHANGEVSENDOFLASTRECESSION(state,recessioncriteriachangevsendoflastrecession){
    state.recessioncriteriachangevsendoflastrecession = recessioncriteriachangevsendoflastrecession;
},
SET_IMPACTOF10SWINGINCUNSUMERDEMANDONSUPPLIERS(state,impactofswingincunsumerdemandonsuppliers){
    state.impactofswingincunsumerdemandonsuppliers = impactofswingincunsumerdemandonsuppliers;
},
SET_RATIOCONINCIDENTLAGGINGLEIYOYVSRECESSIONTIMING(state,ratioconincidentlaggingleiyoyvsrecessiontiming){
    state.ratioconincidentlaggingleiyoyvsrecessiontiming = ratioconincidentlaggingleiyoyvsrecessiontiming;
},
SET_GLOBAL_STATE_FOR_WHOLE_PROJECT(state,globalStateForWholeProject){
    state.globalStateForWholeProject = globalStateForWholeProject;
},



};
export default {
  state,
  getters,
  actions,
  mutations,
};
